<template>
  <div>
    <v-col cols="12">
      <v-col cols="12">
        <v-row>
          <v-col cols="2">
            <router-link
              :to="linkBack2"
              style="text-decoration: none"
              title="Back"
            >
              <v-btn
                color="warning"
                fab
                small
                dark
                style="float: left; margin-left: 5px"
              >
                <v-icon class="fa fa-arrow-left"></v-icon>
              </v-btn>
            </router-link>
          </v-col>
          <v-col cols="8">
            <b>TaskID:</b>{{ dataTask._id }} - <b>Designer: </b
            >{{ dataTask.designer }} - <b>Assigner: </b
            >{{ dataTask.assigner }} - <b>Status: </b>{{ dataTask.status }} -
            <b>ProductID: </b>
            <template v-if="dataProduct != null">
              <template
                v-if="
                  dataProduct.original_designs != undefined &&
                  dataProduct.original_designs.length > 0
                "
              >
                <template v-if="dataTask.type == 'Personalize Design'">
                  <a
                    :href="
                      '/personalize-products?searchBy=product_id&searchWord=' +
                      dataTask.product_id
                    "
                    target="_blank"
                    style="text-decoration: none"
                  >
                    {{ dataTask.product_id }}
                  </a>
                </template>
                <template v-else-if="dataTask.type == 'Crawl Design'">
                  <a
                    :href="
                      '/products?searchBy=product_id&searchWord=' +
                      dataTask.product_id
                    "
                    target="_blank"
                    style="text-decoration: none"
                  >
                    {{ dataTask.product_id }}
                  </a>
                </template>
                <template v-else-if="dataTask.type == 'Normal Design'">
                  <a
                    :href="
                      '/normal-products?searchBy=product_id&searchWord=' +
                      dataTask.product_id
                    "
                    target="_blank"
                    style="text-decoration: none"
                  >
                    {{ dataTask.product_id }}
                  </a>
                </template>
              </template>
              <template v-else>
                {{ dataTask.product_id }}
              </template>
            </template>
            <template v-else>
              {{ dataTask.product_id }}
            </template>
          </v-col>
          <v-col cols="2">
            <template v-if="dataTask.status == 'Need Review'">
              <template v-if="roles.review_task || userId == 'hoaiht'">
                <v-btn color="success" small @click="confirmDesign"
                  >Confirm</v-btn
                >&nbsp;
                <v-btn color="red" small @click="denyDesign" dark>Deny</v-btn>
              </template>
            </template>
          </v-col>
        </v-row>

        <div>
          <b v-if="informSave" style="color: green">{{ informSaveText }}</b>
          <b v-else style="color: red">{{ informSaveText }}</b>
        </div>
      </v-col>

      <v-col cols="12" v-if="inform != ''">
        <template v-if="inform">
          <b style="color: green">{{ informText }}</b>
        </template>
        <template v-else>
          <b style="color: red">{{ informText }}</b>
        </template>
      </v-col>

      <v-col cols="12" class="border">
        <v-row>
          <v-col cols="2" style="text-align: center">
            <b>Design Position: </b>
            <div style="color:red;font-size:larger">{{ dataTask.design_position }}</div>
          </v-col>
          <v-col cols="2" style="text-align: center">
            <b>Working Time: </b>
            <div>{{ workingTime }}</div>
          </v-col>
          <v-col cols="2" style="text-align: center">
            <b>Deny Count: </b>
            <div>{{ dataTask.deny_count }}</div>
          </v-col>
          <v-col cols="2" style="text-align: center">
            <b>Design Type: </b>
            <div>{{ dataTask.product_design_type }}</div>
          </v-col>
          <v-col cols="2" style="text-align: center">
            <b>PSD Already Exist: </b>
            <div>
              <template v-if="dataProduct != null">
                <template
                  v-if="
                    dataProduct.original_designs != undefined &&
                    dataProduct.original_designs.length > 0
                  "
                >
                  <v-chip color="success">YES</v-chip>
                </template>
                <template v-else>NO</template>
              </template>
              <template v-else>NO</template>
            </div>
          </v-col>
          <v-divider vertical></v-divider>
          <!-- <template
            v-if="
              dataTask.product_design_type == 'Crawl Design' ||
              dataTask.product_design_type == 'upload_photo'
            "
          >
            <v-col
              cols="3.5"
              style="text-align: center"
              v-if="dataTask.status == 'Need Review' && roles.review_task"
            >
              <b>Rating (%): </b>
              <v-row>
                <v-col cols="5.5">
                  <v-select
                    :items="ratingList"
                    label="Choose One"
                    dense
                    outlined
                    v-model="rating"
                    @change="clearText"
                  ></v-select>
                </v-col>
                &nbsp;
                <v-col cols="5.5">
                  <v-text-field
                    label="Other"
                    v-model="ratingOther"
                    @keyup="clearDropdown"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="3.5" style="text-align: center" v-else>
              <b>Rating (%): </b>
              <div v-if="dataTask.rating > 0">{{ dataTask.rating * 100 }}</div>
            </v-col>
          </template> -->
        </v-row>
      </v-col>

      <v-col cols="12" style="text-align: left" class="border">
        <div><b>Related Order(s): </b></div>
        <div v-for="(i, index) in dataTask.related_orders" :key="index">
          <b>{{ i.order_number }}:</b> {{ i.item_name }}
        </div>
        <v-row>
          <v-col cols="9">
            <v-textarea
              label="Note"
              auto-grow
              rows="1"
              row-height="15"
              v-model="dataTask.note"
              @change="showSaveTaskBtn"
              @keyup="showSaveTaskBtn"
            ></v-textarea>
          </v-col>
          <v-col cols="2">
            <v-select
              :items="listDesigner"
              :item-text="(obj) => obj.name"
              :item-value="(obj) => obj.username"
              label="Select Designer"
              dense
              outlined
              v-model="dataTask.designer"
              @change="showSaveTaskBtn"
            ></v-select>
          </v-col>
          <v-col cols="1" v-if="roles.review_task || userId == 'hoaiht'">
            <v-btn color="light-blue" dark @click="saveData" v-if="showTaskBtn"
              >Save</v-btn
            >
            <v-btn disabled v-else>Save</v-btn>
            <!-- <v-btn @click="check">Check</v-btn> -->
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12">
        <v-row>
          <v-col cols="5" class="border">
            <template v-if="dataTask.type != 'Personalize Design'">
              <b>Image Preview</b>
              <!-- <v-row>
                            <v-col cols="4" v-for="i in dataProduct.preview_imgs" :key="i.img_id">
                                <img v-bind:src="i.img_url" style="height:70px">
                            </v-col>
                        </v-row> -->
              <template v-if="dataProduct != null">
                <v-carousel>
                  <v-carousel-item
                    v-for="i in dataProduct.preview_imgs"
                    :key="i.img_id"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
                  >
                    <img
                      :src="i.img_url"
                      :alt="i.image_url"
                      style="height: 80%"
                    />
                  </v-carousel-item>
                </v-carousel>
              </template>

              <div v-else>No Preview Image Available</div>
              <v-row v-if="dataTask.customer_choice != undefined">
                <v-col
                  cols="6"
                  v-for="(i, index) in dataTask.customer_choice"
                  :key="index"
                  style="text-align: left"
                >
                  <b style="color: green">{{ index + 1 }} - {{ i.name }}</b
                  >: &nbsp;
                  <template v-if="i.value != null">
                    <template v-if="i.value.includes('http')"
                      ><a :href="i.value" target="_blank">Link</a></template
                    >
                    <template v-else>{{ i.value }}</template>
                  </template>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <b>Customer Choice</b>
              <v-row v-if="dataTask.customer_choice.length > 0">
                <v-col
                  cols="6"
                  v-for="(i, index) in dataTask.customer_choice"
                  :key="index"
                  style="text-align: left"
                >
                  <!-- <template v-for="value in i">
                                {{value}}
                            </template> -->
                  <b style="color: green">{{ index + 1 }} - {{ i.name }}</b
                  >: &nbsp;
                  <template v-if="i.value != null">
                    <template v-if="i.value.includes('http')"
                      ><a :href="i.value" target="_blank">Link</a></template
                    >
                    <template v-else><span style="white-space: pre;">{{ i.value }}</span></template>
                  </template>
                </v-col>
              </v-row>
            </template>
          </v-col>
          <v-col cols="7" class="border" ref="previewDesign">
            <b>Preview Design</b>
            <template
              v-if="dataTask.design_url != '' && dataTask.design_url != null"
            >
              <!-- <v-col cols="12">
                            <img :src="dataTask.design_url" style="height:30em">
                        </v-col>    -->
              <!-- <v-stage ref="stage" :config="stageSize">
                <v-layer ref="layer">
                  <v-image
                    :config="{
                      image: image,
                      opacity: opacityImage,
                      width: imageSize.widthScale,
                      height: imageSize.heightScale,
                    }"
                  />

                  <v-image
                    :config="{
                      image: image2,
                      opacity: opacityDesign,
                      width: imageSize2.widthScale,
                      height: imageSize2.heightScale,
                    }"
                    v-if="showTemplate"
                  />

                  <v-image
                    :config="{
                      image: image3,
                      opacity: opacityDesign,
                      width: imageSize3.widthScale,
                      height: imageSize3.heightScale,
                    }"
                    v-if="showCheckSpell"
                  />
                </v-layer>
              </v-stage> -->

              <v-col cols="12">
                <img
                  :src="image"
                  width="450px"
                  style="position: absolute"
                  :style="{ opacity: opacityImage }"
                />
                <img
                  :src="image2"
                  width="450px"
                  :style="{ opacity: opacityDesign }"
                />
              </v-col>

              Size: {{ sizeDesign }}
              <v-icon color="orange" v-if="sizeDesign != templateSize"
                >mdi-alert</v-icon
              >

              <v-row>
                <v-col cols="7">
                  <v-slider
                    label="Opacity"
                    v-model="opacityImage"
                    class="align-self-stretch"
                    min="0"
                    max="1"
                    step="0.01"
                  ></v-slider>
                </v-col>
                <v-col cols="5">
                  <v-btn
                    small
                    @click="
                      showTemplate = true;
                      showCheckSpell = false;
                    "
                    >Template</v-btn
                  >
                  <!-- &nbsp;
                  <v-btn
                    small
                    @click="
                      showTemplate = false;
                      showCheckSpell = true;
                    "
                    v-if="dataTask.spell_checking_url"
                    >Check Spelling</v-btn
                  > -->
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-stage ref="stage" :config="stageSize">
                <v-layer ref="layer">
                  <v-image
                    :config="{
                      image: image,
                      width: imageSize.widthScale,
                      height: imageSize.heightScale,
                    }"
                  />
                </v-layer>
              </v-stage>
            </template>
          </v-col>

          <v-col
            cols="12"
            class="border"
            v-if="this.templateVendor.length != 0"
          >
            <v-row>
              <v-col cols="6">
                <!-- <a :href="this.templateVendor.template_url" target="_blank">Template URL</a>-->
                <template v-if="dataTask.original_design_url != ''"
                  ><a
                    :href="dataTask.original_design_url"
                    style="text-decoration: none"
                    >Download Design PSD</a
                  >
                  |
                </template>

                <v-menu
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-x
                  persistent
                >
                  <template v-slot:activator="{ on, attrs }">
                    <a v-bind="attrs" v-on="on"> Link Template </a>
                  </template>
                  <v-card class="mx-auto" max-width="344" outlined>
                    <div
                      v-for="(j, index) in templateVendor.template_url.split(
                        ','
                      )"
                      :key="index"
                      style="padding: 5px; text-align: left"
                    >
                      <b>({{ index + 1 }}):</b> {{ j }}
                    </div>
                  </v-card>
                </v-menu>

                <template v-if="dataTask.design_url != ''">
                  |
                  <a
                    :href="this.dataTask.design_url"
                    style="text-decoration: none"
                    target="_blank"
                    >Download Design</a
                  ></template
                >
              </v-col>
              <v-col cols="6">Template Size: {{ templateSize }} </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="border" v-if="roles.update_task">
            <template>
              <!-- <v-radio-group v-model="uploadDesign" :mandatory="false" class="large" row>
                            <v-radio label="URL" value="url" @change="reset"></v-radio>&nbsp;
                            <v-radio label="Upload Design" value="file" @change="reset"></v-radio>
                        </v-radio-group> -->

              <!-- <template v-if="uploadDesign == 'url'"> -->
              <v-text-field
                label="Design URL"
                v-model="designURL"
                @change="checkURL"
                @keyup="checkURL"
                outlined
                dense
              ></v-text-field>
              <v-text-field
                label="Design PSD File"
                v-model="designPSD"
                @change="checkURL"
                @keyup="checkURL"
                outlined
                dense
                style="margin-top: 10px"
              ></v-text-field>
              <v-btn
                color="blue"
                dark
                v-if="showBtnURL"
                @click="
                  loader = 'loading';
                  imageURLSave();
                "
                :loading="loading"
                :disabled="loading"
              >
                Save URL
                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>mdi-loading</v-icon>
                  </span>
                </template>
              </v-btn>
              <v-btn color="blue" v-else disabled>Save URL</v-btn>
              <v-alert v-if="errorMess != ''" type="error">{{
                errorMess
              }}</v-alert>
              <p style="color: red" v-if="informTextURL != ''">
                {{ informTextURL }}
              </p>
              <template v-if="designURL != ''">
                <v-col cols="12">
                  <img :src="designURL" style="height: 30em" />
                </v-col>
                Size: {{ sizeURL }}
                <v-icon color="orange" v-if="sizeURL != templateSize"
                  >mdi-alert</v-icon
                >
              </template>

              <!-- </template>

                        <template v-else-if="uploadDesign == 'file'">
                            <input type="file" @change="onFileDesignChange" ref="inputDesign" style="display:none;">
                            <v-btn @click="$refs.inputDesign.click()" color="light-blue" dark v-if="showBtn">Select Design</v-btn>
                            <v-btn v-else disabled>Select Design</v-btn>&nbsp;
                            <v-btn color="success" @click="loader='loading';uploadImagePreview()" v-if="imageDesign.length > 0" :loading="loading" :disabled="loading">
                                Upload Design
                                <template v-slot:loader>
                                    <span class="custom-loader">
                                    <v-icon light>mdi-loading</v-icon>
                                    </span>
                                </template>
                            </v-btn>&nbsp;
                            <v-btn color="red" @click="reset" v-if="imageDesign.length > 0 && showBtn == true" dark>Cancel</v-btn>
                            <v-btn v-else disabled>Cancel</v-btn>
                            <v-col cols="12" v-if="errorMess!=''" style="margin-top:5px">
                                <v-alert type="error">
                                    {{ errorMess }}
                                </v-alert>
                            </v-col>
                            <template v-if="imageDesign.length > 0" style="text-algin:center">
                                <v-col cols="12">
                                    <img v-bind:src="imageDesign[0].image" style="height:30em">
                                </v-col>
                                Size: {{size}} <v-icon color="orange" v-if="size != templateSize">mdi-alert</v-icon>
                            </template>
                        </template> -->
            </template>
          </v-col>

          <v-col cols="12" class="border" v-if="dataTask.old_design_url != ''">
            <v-text-field
              label="Design URL"
              v-model="dataTask.old_design_url"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-col>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
//import Vue from "vue";
//import HTTP from "../http-common"
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

//const MAX_IMAGE_SIZE = 6300000
//console.loh(width)
export default {
  name: "Task_Edit",

  data: () => ({
    params2: "",
    linkBack2: "",
    dataTask: [],
    dataProduct: [],
    listDesigner: [],
    uploadDesign: "",
    designURL: "",
    designPSD: "",
    imageDesign: [],
    imageFormat: "",
    size: "",
    sizeDesign: "",
    sizeURL: "",
    dataVendor: [],
    templateVendor: [],
    templateSize: "",
    showBtnURL: false,
    showBtn: true,
    showTaskBtn: false,
    inform: "",
    informText: "",
    informTextURL: "",
    informSave: false,
    informSaveText: "",
    loader: null,
    loading: false,
    listOrder: [],
    dataTaskTemp: [],
    errorMess: "",
    userId: "",
    workingTime: "",
    rating: "",
    ratingOther: "",

    opacityImage: 1,
    opacityDesign: 0,
    stageSize: {
      width: 0,
      height: 0,
    },
    imageSize: {
      width: 0,
      height: 0,
    },
    imageSize2: {
      width: 0,
      height: 0,
    },
    imageSize3: {
      width: 0,
      height: 0,
    },
    image: null,
    image2: null,
    image3: null,
    showCheckSpell: false,
    showTemplate: true,
    ratingList: ["50", "60", "70", "80", "90", "100", "150", "200"],
    roles: [],
  }),

  watch: {
    designURL() {
      this.getSizeURL();
    },
    opacityImage() {
      this.opacityDesign = 1 - this.opacityImage;
    },
  },

  methods: {
    getSize() {
      console.log("get Size");
      console.log("previewDesign: ", this.$refs.previewDesign);

      this.stageSize.height = this.$refs.previewDesign.clientHeight;
      this.stageSize.width = this.$refs.previewDesign.clientWidth;
      console.log(
        this.$refs.previewDesign.clientHeight +
          "-" +
          this.$refs.previewDesign.clientWidth
      );
    },

    loadDesignPreview() {
      this.image = this.dataTask.design_url;
      this.image2 = this.dataVendor.design_templates[0].template_url;
      if (this.image2.length < 1) {
        this.image2 = this.image;
      }
      this.image3 = this.dataTask.spell_checking_url;
    },

    // loadDesignPreview() {
    //   //template
    //   const image = new window.Image();

    //   image.src = this.dataTask.design_url;
    //   image.onload = () => {
    //     this.image = image;
    //     this.imageSize.width = image.width;
    //     this.imageSize.height = image.height;

    //     var x = this.imageSize.height / 450;
    //     this.imageSize["widthScale"] = this.imageSize.width / x;
    //     this.imageSize["heightScale"] = this.imageSize.height / x;
    //   };

    //   //design
    //   if (this.dataVendor.design_templates.length > 0) {
    //     const image2 = new window.Image();
    //     image2.src = this.dataVendor.design_templates[0].template_url;
    //     image2.onload = () => {
    //       this.image2 = image2;
    //       this.imageSize2.width = image2.width;
    //       this.imageSize2.height = image2.height;

    //       var x = this.imageSize2.height / 450;
    //       this.imageSize2["widthScale"] = this.imageSize2.width / x;
    //       this.imageSize2["heightScale"] = this.imageSize2.height / x;
    //     };
    //   }

    //   //check spell
    //   if (this.dataTask.spell_checking_url) {
    //     const image3 = new window.Image();
    //     image3.src = this.dataTask.spell_checking_url;
    //     image3.onload = () => {
    //       // set image only when it is loaded
    //       this.image3 = image3;
    //       this.imageSize3.width = image3.width;
    //       this.imageSize3.height = image3.height;

    //       var x = this.imageSize3.height / 450;
    //       this.imageSize3["widthScale"] = this.imageSize3.width / x;
    //       this.imageSize3["heightScale"] = this.imageSize3.height / x;
    //     };
    //   }

    //   // console.log('imageSize: ',this.imageSize)
    //   // console.log('imageSize2: ',this.imageSize2)
    //   // console.log('imageSize3: ',this.imageSize3)
    // },

    async loadData() {
      this.listOrder = [];
      var currentSession = await this.$root.$refs.App.currentSession(
        "task-edit-loadData"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        if (this.$route.params.id != undefined) {
          await axios
            .get(window.domain + "tasks/" + this.$route.params.id, {
              headers: { Authorization: currentSession.accessToken },
            })
            .then((response) => {
              console.log("loadData taskEdit: ", response);
              this.dataTask = response.data.data.task;
              this.dataProduct = response.data.data.product;
              this.dataVendor = response.data.data.vendor;
              this.listDesigner = response.data.data.designers;
              //this.designPSD = response.data.data.task.original_design_url;
              this.dataTaskTemp = Object.assign({}, this.dataTask);

              if (
                this.dataTask.status == "Need Review" ||
                this.dataTask.status == "Completed"
              ) {
                var timeDiff = moment(this.dataTask.last_updated_date).diff(
                  moment(this.dataTask.created_date),
                  "hours"
                );
                console.log(timeDiff);
                var dayTemp = 0;
                var hourTemp = 0;

                dayTemp = parseInt(timeDiff / 24);
                hourTemp = timeDiff % 24;

                this.workingTime = dayTemp + "d " + hourTemp + "h";
              } else {
                this.workingTime = moment(this.dataTask.created_date).fromNow();
              }

              let img = new Image();
              img.src = this.dataTask.design_url;
              img.onload = () => {
                this.sizeDesign = img.width + "x" + img.height;
              };

              // for(const i of this.dataVendor.design_templates){
              //     // console.log("dataVendor: ",i)
              //     // console.log("variant_id: ",this.dataTask.variant_id)
              //     if(this.dataTask.variant_id == i.variant_id){
              //         console.log("OK")
              //         this.templateVendor = i
              //         this.templateSize = this.templateVendor.width + "x" + this.templateVendor.height
              //     }
              // }

              //console.log('length: ',this.dataVendor.design_templates.length)
              if (this.dataVendor.design_templates.length > 0) {
                this.templateVendor = this.dataVendor.design_templates[0];
                this.templateSize =
                  this.dataVendor.design_templates[0].width +
                  "x" +
                  this.dataVendor.design_templates[0].height;
              }

              for (const j of this.dataTask.related_orders) {
                this.listOrder.push(j.order_number);
              }

              console.log("workingTime: ", this.workingTime);

              this.loadDesignPreview();
              // console.log("this.dataTask: ",this.dataTask)
              // console.log("this.dataProduct: ",this.dataProduct)
              // console.log("templateVendor: ",this.templateVendor)
            })
            .catch((error) => {
              console.log("error ", error);
            });
        }
      } else {
        console.log(
          "currentSession task-edit-loadData-undefined: ",
          currentSession
        );
      }
    },

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    showSaveTaskBtn() {
      if (
        this.dataTask.note != this.dataTaskTemp.note ||
        this.dataTask.designer != this.dataTaskTemp.designer
      ) {
        this.showTaskBtn = true;
      } else {
        this.showTaskBtn = false;
      }
    },

    async saveData() {
      var item = {
        note: this.dataTask.note,
        designer: this.dataTask.designer,
      };

      console.log(JSON.stringify(item));

      var currentSession = await this.$root.$refs.App.currentSession(
        "task-edit-saveData"
      );
      if (currentSession.accessToken) {
        fetch(window.domain + "tasks/" + this.$route.params.id, {
          method: "PUT",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify(item),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("task-edit-saveData response: ", data);
            if (data.error_message != "") {
              this.informSave = false;
              this.informSaveText = data.error_message;
            } else {
              this.informSave = true;
              this.informSaveText = "Save Completed!";
              this.dataTask = data.data.task;
              this.dataTaskTemp = Object.assign({}, this.dataTask);
              this.showSaveTaskBtn();
            }
          })
          .catch((error) => console.log("Error: ", error));
      } else {
        console.log(
          "currentSession task-edit-saveData-undefined: ",
          currentSession
        );
      }

      await this.sleep(3000);
      this.informSaveText = "";
    },

    checkURL() {
      console.log("Check: ", this.designURL.indexOf("https://gba-public.s3"));
      if (this.designURL.indexOf("https://gba-public.s3") > -1) {
        if (this.designPSD != "") {
          if (this.designPSD.indexOf("https://gba-public.s3") > -1) {
            this.showBtnURL = true;
            this.informTextURL = "";
          } else {
            this.showBtnURL = false;
            this.informTextURL =
              "Design image/PSD file must be saved in gba-public folder of Amazon S3";
          }
        } else {
          this.showBtnURL = true;
          this.informTextURL = "";
        }
      } else {
        this.showBtnURL = false;
        this.informTextURL =
          "Design image/PSD file must be saved in gba-public folder of Amazon S3";
      }
      console.log("showBtnURL: ", this.showBtnURL);
    },

    getSizeURL() {
      let img = new Image();
      img.src = this.designURL;
      img.onload = () => {
        this.sizeURL = img.width + "x" + img.height;
      };
    },

    // reset(){
    //     this.errorMess = ""
    //     this.designURL = '';
    //     this.imageDesign = [];
    //     this.imageFormat = '';
    //     this.size = '';
    //     this.sizeURL = '';
    //     if(this.$refs.inputDesign != undefined)
    //         this.$refs.inputDesign.value = '';
    // },

    async confirmDesign() {
      var r = confirm("Are you sure you want to confirm this task?");
      if (r != false) {
        var currentSession = await this.$root.$refs.App.currentSession(
          "task-edit-confirm"
        );
        var data = {
          task_id: this.dataTask._id,
          is_confirmed: "yes",
        };

        // if (this.rating != "") {
        //   data["rating"] = this.rating;
        // } else if (this.ratingOther != "") {
        //   data["rating"] = this.ratingOther;
        // }

        //console.log('currentSession: ',currentSession.accessToken)
        if (currentSession.accessToken) {
          await fetch(window.domain + "tasks/confirm-design", {
            method: "POST",
            headers: { Authorization: currentSession.accessToken },
            body: JSON.stringify(data),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("confirmDesign: ", data);
              this.dataTask = [];
              this.dataTask = data.data;
              let img = new Image();
              img.src = this.dataTask.design_url;
              img.onload = () => {
                this.sizeDesign = img.width + "x" + img.height;
              };
            })
            .catch((error) => {
              console.log("Err: ", error);
            });

          //this.loadData()
        } else {
          console.log(
            "currentSession task-edit-confirm-undefined: ",
            currentSession
          );
        }
      }
    },

    async denyDesign() {
      var r = confirm("Are you sure you want to deny this task?");
      if (r != false) {
        var currentSession = await this.$root.$refs.App.currentSession(
          "task-edit-delete"
        );
        //console.log('currentSession: ',currentSession.accessToken)
        if (currentSession.accessToken) {
          await fetch(window.domain + "tasks/confirm-design", {
            method: "POST",
            headers: { Authorization: currentSession.accessToken },
            body: JSON.stringify({
              task_id: this.dataTask._id,
              is_confirmed: "no",
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("denyDesign: ", data);
              this.dataTask = [];
              this.dataTask = data.data;
              let img = new Image();
              img.src = this.dataTask.design_url;
              img.onload = () => {
                this.sizeDesign = img.width + "x" + img.height;
              };
            })
            .catch((error) => {
              console.log("Err: ", error);
            });

          //this.loadData()
        } else {
          console.log(
            "currentSession task-edit-delete-undefined: ",
            currentSession
          );
        }
      }
    },

    async imageURLSave() {
      const l = this.loader;
      this[l] = !this[l];
      var currentSession = await this.$root.$refs.App.currentSession(
        "task-edit-imageURLSave"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        var response = await fetch(window.domain + "tasks/upload-design", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify({
            task_id: this.dataTask._id,
            product_id: this.dataTask.product_id,
            image_format: "",
            image_base64: "",
            image_url: this.designURL,
            original_design_url: this.designPSD,
          }),
        })
          .then((response) => response.json())
          .catch((error) => {
            console.log("Err: ", error);
          });
        console.log("imageURLSave: ", response);
        if (response.error_message == "") {
          this.loadData();

          this[l] = false;
          this.loader = null;
          this.designURL = "";
          this.showBtnURL = false;
          this.uploadDesign = "";
          this.designPSD = "";
          //this.loadData();
        } else {
          this.errorMess = response.error_message;
        }
      } else {
        console.log(
          "currentSession task-edit-imageURLSave-undefined: ",
          currentSession
        );
      }
    },

    clearText() {
      this.ratingOther = "";
    },

    clearDropdown() {
      this.rating = "";
    },

    check() {
      console.log(this.dataTask);
      console.log(this.rating);
      console.log(this.ratingOther);
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("task");

    this.getSize();
    //console.log('stageSize: ',this.stageSize)
    this.params2 = window.location.search;
    this.linkBack2 = "/tasks" + this.params2;

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      var currentSession = await this.$root.$refs.App.currentSession(
        "editTask-mounted"
      );
      this.userId = currentSession.username;

      if (this.roles.read_task || this.userId == "hoaiht") {
        this.loadData();
      } else {
        this.$router.push("/not-authorized");
      }
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
